import React from "react";
import logo from "../amazon-logo.svg";
export default class LoginHeader extends React.Component {
    render() {
        return (
            <div className="login-header" id="header">
                <img
                    src={logo}
                    alt={this.props.config.product}
                />
                <span>
                    <span className="line">{this.props.config.headline}</span>
                </span>
            </div>
        );
    }
}
